/**
    热卖商品
**/
<template>
  <div class="leftaside">
    <h4>{{navTitle}}</h4>
    <ul class="left_product">
      <li v-for="(item,index) in articleList" :key="index">
          <el-row :gutter="10">
              <el-col :span='8'>
                  <!-- <div class="p-img"> -->
                    <router-link
                        class="item_link"
                        :to='`/siteHelpDetail?itemId=${item.articleId}`'
                        @click.native="$router.go(0)"
                    >
                        <el-image
                        class="img-responsive"
                       :src="item.articleImage"
                        style="display: block"
                        >
                             <div slot="error" class="image-slot">
                                    <i class="el-icon-picture-outline"></i>
                            </div>
                        </el-image>
                    </router-link>
                    <!-- </div> -->
              </el-col>
              <el-col :span='16'>
                  <div class="pro_name">
                    <router-link :to='`/siteHelpDetail?itemId=${item.articleId}`'>{{item.articleTitle}}</router-link>
                    </div>
                    <div class="descript">
                        <div><i class="el-icon-chat-round"></i> {{item.articleCount}}</div>
                        <div><i class="el-icon-date"></i> {{item.createTime}}</div>
                    </div>
                    
              </el-col>
          </el-row>
        <el-divider></el-divider>
        
      </li>
      <li>
          <div class="nodate" v-if="articleList.length==0?true:false">
            <div class="first">暂无热销商品</div>
          </div>
      </li>
    </ul>
  </div>
</template>
<script>
export default {
  data() {
    return {
    //   centerDialogVisible: false,
    //   successInfo: true,
    //   addGoodsName: "洁面膏100g温和清洁泡沫",
    //   checked1: "",
	//   checked2: "",
	//   rightGoodsList:[],
    };
  },
 props: ['navTitle','articleList'],
  // 注册组件
  components: {},
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {},

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
  },
};
</script>

<style scoped lang='less'>
.leftaside {
  width:"200px";
  /* background: pink; */
  /* padding: 10px; */
  box-sizing: border-box;
  font-size: 14px;
  border: 1px solid #ddd;
  /* margin-right: 10px; */
  a.item_link {
        display: inline-block;
    background: #ececec;
    height: 60px;
    width: 100%;
    vertical-align: text-top;
    /deep/.image-slot {
        line-height: 60px;
        text-align: center;
    }
}
}
.leftaside h4 {
    font-size: 15px;
    font-weight: 800;
    padding: 10px 20px;
    border-bottom: 1px solid #ccc;
}
.left_product {
  padding: 10px;
}
.left_product li {
  margin-bottom: 30px;
}
.pro_name {
  text-overflow: -o-ellipsis-lastline;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
  font-size: 14px;
//   margin: 10px 0;
}
.descript {
    color: #999;
}
.img-responsive {
  /* width: 100%; */
   /* width: 160px;
  height: 160px; */
}

.nodate{
    text-align: center;
    margin-top: 20%;
    font-size: 16px;
}
.nodate .first {
	margin: 40upx 0 12upx;
	font-size: 28upx;
}
</style>

 
 

 


// WEBPACK FOOTER //
// src/components/hotArticle.vue